import React, { useState, useMemo, useCallback} from 'react';
import DataGrid, { Filters, SortDirection } from 'react-data-grid';
import * as d3 from 'd3';

import './grid.css';
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';

const selectedHighlightClassname = "selectedHighlightClassname";

function Screen2Grid(props:any) {

    const [[sortColumn, sortDirection], setSort] = useState<[string, SortDirection]>(['bulk_name', 'NONE']);
    const handleSort = useCallback((columnKey: string, direction: SortDirection) => {
        setSort([columnKey, direction]);
      }, []);

    const [filters, setFilters] = useState<Filters>({
    bulk_name: '',
    tissue_group:'',
    germ_layer_group: '',
    left_right_axis: '',
    cranio_caudal_axis: ''
    });
    const [enableFilterRow, setEnableFilterRow] = useState(true);

    let bulkTileData:any = props.bulkTileData;
    const initData:any  = props.initialization;
    const colorRange:string[] = ['#ff0000', '#4B0082','#FFACB7','#FFB400','#BC8F8F','#C71585','#B8860B','#8B0000','#006400','#8FBC8F','#1E90FF','#FF00FF','#8A2BE2','#EF904C','##FFFFE0']

    let selectedRowBulkId:string;

    let color:any = d3.scaleOrdinal().range(colorRange)

    const rows:any[] = createRows();

    function createRows() {
        let rows: any[] = [];
        if(bulkTileData){
            let keys:string[] = Object.getOwnPropertyNames(bulkTileData);
            keys.sort();

            
            keys.forEach(key => {
                let row:any = bulkTileData[key];
                if(row){
                    row.color = color(row.tissue_group);
                    rows.push(row);
                }
            });
        }
        return rows;
    }

    const columns = useMemo(() =>{
        return [
            { 
                key: 'bulk_name',          name: 'Bulk Name', frozen: true, sortable: true, resizable: true, width: 150,
                filterRenderer: (p:any) => (
                    <Form.Group>
                    <Form.Control size="sm" type="text" placeholder="Filter Text" value={p.value} onChange={e => p.onChange(e.target.value)}/>
                    </Form.Group>
                ),
                formatter(selectedData:any){
                    return (
                        <OverlayTrigger transition={false} overlay={<Tooltip id="tooltip-disabled">{selectedData.row.bulk_name}</Tooltip>}>
                        <div className="fill-grid-column">{selectedData.row.bulk_name}</div>
                        </OverlayTrigger>
                    );
                }
            },
            { 
                key: 'tissue_group',       name: 'Cell type', sortable: true,resizable: true, width: 90,
                filterRenderer: (p:any) => (
                    <Form.Group>
                    <Form.Control size="sm" type="text" placeholder="Filter Text" value={p.value} onChange={e => p.onChange(e.target.value)}/>
                    </Form.Group>
                ),
                formatter(selectedData:any){
                    return (
                        <OverlayTrigger transition={false} overlay={<Tooltip id="tooltip-disabled">{selectedData.row.tissue_group}</Tooltip>}>
                            <div className="fill-grid-column">{selectedData.row.tissue_group}</div>
                        </OverlayTrigger>
                    )
                }
            },
            { 
                key: 'germ_layer_group',   name: 'Germ layer group', sortable: true,resizable: true, 
                filterRenderer: (p:any) => (
                    <Form.Group>
                    <Form.Control size="sm" type="text" placeholder="Filter Text" value={p.value} onChange={e => p.onChange(e.target.value)}/>
                    </Form.Group>
                ),
                formatter(selectedData:any){
                    return (
                        <OverlayTrigger transition={false} overlay={<Tooltip id="tooltip-disabled">{selectedData.row.germ_layer_group}</Tooltip>}>
                            <div className="fill-grid-column">{selectedData.row.germ_layer_group}</div>
                        </OverlayTrigger>
                    )
                }
            },
            { 
                key: 'left_right_axis',    name: 'Left right axis', sortable: true,resizable: true,
                filterRenderer: (p:any) => (
                    <Form.Group>
                    <Form.Control size="sm" type="text" placeholder="Filter Text" value={p.value} onChange={e => p.onChange(e.target.value)}/>
                    </Form.Group>
                ),
                formatter(selectedData:any){
                    return (
                        <OverlayTrigger transition={false} overlay={<Tooltip id="tooltip-disabled">{selectedData.row.left_right_axis}</Tooltip>}>
                            <div className="fill-grid-column">{selectedData.row.left_right_axis}</div>
                        </OverlayTrigger>
                    )
                }
            },
            { 
                key: 'cranio_caudal_axis', name: 'Cranio caudal axis', sortable: true,resizable: true,
                filterRenderer: (p:any) => (
                    <Form.Group>
                    <Form.Control size="sm" type="text" placeholder="Filter Text" value={p.value} onChange={e => p.onChange(e.target.value)}/>
                    </Form.Group>
                ),
                formatter(selectedData:any){
                    return (
                        <OverlayTrigger transition={false} overlay={<Tooltip id="tooltip-disabled">{selectedData.row.cranio_caudal_axis}</Tooltip>}>
                            <div className="fill-grid-column">{selectedData.row.cranio_caudal_axis}</div>
                        </OverlayTrigger>
                    )
                }
            },
        ];
    },[]);

    const sortedRows = useMemo(() =>{

        let sortedRows: any[] = rows.filter(r => {
            return (
              (filters.bulk_name ? r.bulk_name.includes(filters.bulk_name) : true)
              && (filters.tissue_group ? r.tissue_group.startsWith(filters.tissue_group) : true)
              && (filters.germ_layer_group ? r.germ_layer_group.startsWith(filters.germ_layer_group) : true)
              && (filters.left_right_axis ? r.left_right_axis.startsWith(filters.left_right_axis) : true)
              && (filters.cranio_caudal_axis ? r.cranio_caudal_axis.startsWith(filters.cranio_caudal_axis) : true)
            );
          });

        if (sortDirection === 'NONE') return sortedRows;

        switch (sortColumn) {
            case 'bulk_name':
            case 'tissue_group':
            case 'germ_layer_group':
            case 'left_right_axis':
            case 'cranio_caudal_axis':
              sortedRows = sortedRows.sort((a, b) => a[sortColumn].localeCompare(b[sortColumn]));
              break;
            // case 'complete':
            //   sortedRows = sortedRows.sort((a, b) => a[sortColumn] - b[sortColumn]);
            //   break;
            default:
          }

        return sortDirection === 'DESC' ? sortedRows.reverse() : sortedRows;

    },[rows, sortDirection, sortColumn, filters]);

    function rowClick(rowNum: number, row: any){
        selectedRowBulkId = row.bulk_id;

        if(initData.click_on_row){
            initData.click_on_row(row, true, bulkTileData, rows)   
        }
    }

    return (
        <React.Fragment>
                <DataGrid
                    columns={columns}
                    rows={sortedRows}
                    sortColumn={sortColumn}
                    sortDirection={sortDirection}
                    onSort={handleSort}
                    onRowClick={rowClick}
                    rowHeight={25}
                    headerRowHeight={35}
                    headerFiltersHeight={35}
                    className="fill-grid2"
                    rowClass={row => {
                            if(selectedRowBulkId === row.bulk_id){
                                return selectedHighlightClassname;
                            }
                            return undefined ;
                        }
                    }
                    enableFilterRow={enableFilterRow}
                    filters={filters}
                    onFiltersChange={setFilters}

                />
        </React.Fragment>
    );
}

export default Screen2Grid;